/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import styled from "styled-components";

import {
  getTheme,
  FontSizes,
  FontWeights,
  ICommandBarStyles,
  IDetailsListStyles,
  ILabelStyles,
  IMessageBarStyles,
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  ITextStyles,
} from "@fluentui/react";

const theme = getTheme();

export const bodyContainerStackStyles = (): IStackStyles => {
  return { root: { margin: "1rem 1.5rem", borderRadius: " 0px 0px 8px 8px" } };
};

export const eventsAndActivityBodyContainerStackStyles = (): IStackStyles => {
  return { root: { margin: "1rem 1.5rem", borderRadius: " 0px 0px 8px 8px", overflowX: "scroll" } };
};

export const bodyContainerStackTokens = (): IStackTokens => {
  return { childrenGap: "1rem" };
};

export const labelStyles = (): ILabelStyles => {
  return { root: { fontWeight: 600 } };
};

export const headerStackStyles = (): IStackStyles => {
  return { root: { backgroundColor: "#5B5FC7", borderRadius: "8px 8px 0 0" } };
};

export const bodyRowStackStyles = (): IStackStyles => {
  return { root: { display: "flex", justifyContent: "space-between" } };
};

export const bodyColumnStackItemStyles = (): IStackItemStyles => {
  return { root: { width: "50%" } };
};

export const headerTextStyles = (): ITextStyles => {
  return {
    root: {
      fontWeight: 600,
      fontSize: FontSizes.size20,
      padding: "1rem 1.5rem",
      color: theme.palette.white,
    },
  };
};

export const commandBarStyles: ICommandBarStyles = {
  root: {
    borderRadius: "8px",
    boxShadow: " 0px 1px 4px rgba(0, 0, 0, 0.2)",
    margin: "1rem 0.5rem 1.5rem",
    padding: "0.75rem",
    selectors: {
      ["button"]: {
        marginRight: "36px",
      },
      [".ms-Button-label"]: {
        fontSize: "14px",
        fontWeight: FontWeights.semibold,
      },
      ["i[data-icon-name='Blocked']"]: {
        color: theme.palette.red,
      },
    },
  },
};

export const ContainerWrapper = styled.div`
  background-color: ${theme.palette.white};
  box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 4px;
  border-radius: 8px;
  margin: 1rem 0.5rem 1.5rem;
`;

export const DetailsListWrapper = styled.div`
  padding: 1rem;
  padding-top: 0;
  padding-bottom: 0;
`;

export const TableTextWrapper = styled.div`
  font-size: 14px;
  padding: 0 1rem 1rem 1.5rem;
`;

export const detailsListStyles: Partial<IDetailsListStyles> = {
  root: {
    selectors: {
      ["div[role=row]"]: {
        paddingTop: "0",
      },
    },
  },
};

export const messageBarStyles: IMessageBarStyles = {
  root: {
    backgroundColor: theme.palette.white,
  },
  iconContainer: {
    marginLeft: 0,
  },
  icon: {
    color: theme.palette.themePrimary,
  },
  content: {
    alignItems: "center",
  },
  text: { fontSize: FontSizes.size14 },
};
